/**
 * Aus Sage übernommene Belege sind gesperrt. Pflegbar bleiben der Zahlstatus,
 * der Mahnlauf und die Markierung „an Buchhaltung übergeben“, weil offene
 * Rechnungen nach der Umstellung weiter bezahlt, gemahnt und dem Steuerberater
 * nachgereicht werden. Angebote dürfen zusätzlich abgelehnt werden.
 * Die Liste muss zur Trigger-Ausnahme in
 * supabase/migrations/20261017090000_sage_import_offer_status.sql passen.
 */
export const SAGE_IMPORT_PAYMENT_FIELDS: ReadonlySet<string> = new Set([
  "status",
  "paid_at",
  "paid_amount",
  "skonto_amount",
  "skonto_taken",
  "skonto_due_date",
  "accounting_forwarded_at",
]);

export const SAGE_IMPORT_PAYMENT_STATUSES: ReadonlySet<string> = new Set(["open", "overdue", "paid"]);

/** Zusätzlich zum Zahlstatus: importierte Angebote lassen sich ablehnen. */
export const SAGE_IMPORT_OFFER_STATUSES: ReadonlySet<string> = new Set(["open", "overdue", "paid", "rejected"]);

export function isSageImportPaymentField(field: string): boolean {
  return SAGE_IMPORT_PAYMENT_FIELDS.has(field);
}

export function isSageImportPaymentStatus(status: unknown, documentType?: unknown): boolean {
  const allowed = String(documentType ?? "") === "offer" ? SAGE_IMPORT_OFFER_STATUSES : SAGE_IMPORT_PAYMENT_STATUSES;
  return allowed.has(String(status ?? "").trim());
}
